import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

import { Logo } from '../../atoms/logo';
import { Plus } from '../../atoms/icons/plus';
import { useSelector } from '../../store/utils';

type Props = PropsWithChildren<{
  //
}>;

export const AnimationWrapper = ({ children }: Props) => {
  const premium = useSelector(({ variables }) => variables.PREMIUM);

  const circleBorderSx = {
    position: 'absolute',
    borderStyle: 'solid',
    borderRadius: '50%',
    borderColor: 'primary.main',
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: { xs: 340, sm: 370 },
        position: 'relative',

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        overflow: 'hidden',
      }}
    >
      {children}

      <Box
        sx={{
          width: 106,
          height: 106,
          borderRadius: '50%',
          bgcolor: 'primary.main',

          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          position: 'relative',
        }}
      >
        <Logo
          variant="animation"
          sx={{ fontSize: 40, mb: 0.75, color: 'common.white' }}
        />
        {premium && (
          <Plus sx={{ position: 'absolute', top: 25, right: 30, zIndex: 10 }} />
        )}
        <Box
          sx={{
            inset: -8,
            borderWidth: 3,
            ...circleBorderSx,

            animation: 'pulsing 2000ms ease-in-out infinite',
            '@keyframes pulsing': {
              '0%': { opacity: 0 },
              '90%': { opacity: 1 },
              '100%': { opacity: 0 },
            },

            '&:before': {
              content: '" "',
              inset: -10,
              opacity: 0.6,
              borderWidth: 1,
              ...circleBorderSx,
            },
            '&:after': {
              content: '" "',
              inset: -17,
              borderWidth: 0.3,
              opacity: 0.4,
              ...circleBorderSx,
            },
          }}
        />
      </Box>
    </Box>
  );
};
